import React from 'react'
import Text from '../../components/text/Text'
import {LeagueStatus} from '../../apis/volume_league/list'
import {STATUS_META, STATUS_ORDER} from './constants'

interface IProps {
    statusFilter: 'all' | LeagueStatus
    counts: {[k: string]: number}
    onSelect: (s: 'all' | LeagueStatus) => void
}

/** 상태 필터 칩 (전체 / 준비 중 / 진행 중 / 일시중지 / 종료) */
const StatusFilter: React.FC<IProps> = ({statusFilter, counts, onSelect}) => {
    return (
        <div className="mt-[24px] flex items-center gap-x-[10px] flex-wrap gap-y-[10px]">
            {(['all', ...STATUS_ORDER] as const).map(s => {
                const selected = statusFilter === s
                const label = s === 'all' ? '전체' : STATUS_META[s].label
                return (
                    <div
                        key={s}
                        onClick={() => onSelect(s)}
                        className={`px-[14px] py-[6px] border rounded-full cursor-pointer ${
                            selected ? 'bg-primary border-primary' : 'bg-white border-line02 hover:border-primary'
                        }`}>
                        <Text className={`text-ti3 ${selected ? 'text-white' : 'text-font02'}`}>
                            {label} ({counts[s] ?? 0})
                        </Text>
                    </div>
                )
            })}
        </div>
    )
}

export default StatusFilter
